
import Section from "../Section.vue";
import Card from "../Card.vue";
import { AxiosClient, AxiosClientServerNuxt } from "../../utils/axios";
import { logError } from "../../utils/logError";
import Axios from "axios";
export default {
  components: {
    Section,
    Card,
  },
  props: {
    linkTo: {
      type: String,
      default: "",
    },
  },
  computed: {
    list_school_home_page() {
      return this.$store.state.ListSchool.list_school_home_page;
    },
    list_school_home_page_filter() {
      return this.$store.state.ListSchool.list_school_home_page_filter;
    },
  },
  data() {
    return {
      componentData: [{}, {}, {}, {}, {}],
      schoolMain: {},
      schoolSub: [{}, {}, {}, {}],
      baseImageURL: this.$config.BASE_URL_RESOURCE,
      loading: true,
    };
  },
  async fetch() {
    this.loading = true;
    const domain = this.$config.BASE_URL_CLIENT;
    try {
      // const res = await AxiosClientServerNuxt.get(`/api/school/your-school`);
      const isOnServer = process.server;
      let res;
      // res = await this.$store.dispatch('ListSchool/getListYourSchool')

      if (isOnServer) {
        res = await AxiosClientServerNuxt.get(`/api/school/your-school`, {});
      } else {
        // res = await AxiosClient.get(`/api/school/your-school`, {
        // });
        if (window.location.href.includes("/eduzonelocal")) {
          res = await AxiosClient.get(`/api/school/your-school`, {});
        } else {
          // res = await AxiosServer.get(`/api/school/your-school`, {
          // });
          res = await Axios.get(`${domain}/api/school/your-school`, {});
        }
      }
      if (!Array.isArray(res.data) || res.data.length === 0) {
        this.componentData = [];
        this.schoolMain = {};
        this.schoolSub = [];
      } else if (res.data.length === 1) {
        const [schoolMain] = res.data;
        this.componentData = res.data;
        this.schoolMain = schoolMain;
        this.schoolSub = [];
      } else {
        const [schoolMain, ...schoolSub] = res.data;
        this.componentData = res.data;
        this.schoolMain = schoolMain;
        this.schoolSub = schoolSub;
      }
      this.$store.commit("ListSchool/LIST_SCHOOL_HOME_PAGE", res.data);
    } catch (e) {
      logError(e, "fetch your school on client");

      this.componentData = [];
      this.schoolMain = {};
      this.schoolSub = [];
      this.$store.commit("ListSchool/LIST_SCHOOL_HOME_PAGE", []);
    }
    this.loading = false;
  },
  fetchKey: "comp-yourSchool",
  methods: {
    generateImageURL(params) {
      if (Array.isArray(params)) {
        return this.baseImageURL + params[0];
      } else {
        return this.baseImageURL + params;
      }
    },
  },
};
